module.exports = __webpack_public_path__ + "img/woman-light-small.e9bfa8c7.svg";